import { lazy } from 'react'
// use lazy for better code splitting, a.k.a. load faster
const EntityEditorPage = lazy(() => import('../pages/EntityEditorPage'))
const FormEditorPage = lazy(() => import('../pages/FormEditorPage'))
const WorkflowPage = lazy(() => import('../pages/WorkflowPage'))
const EndpointPage = lazy(() => import('../pages/EndpointPage'))

/**
 * ⚠ These are internal routes!
 * They will be rendered inside the app, using the default `containers/Layout`.
 * If you want to add a route to, let's say, a landing page, you should add
 * it to the `App`'s router, exactly like `Login`, `CreateAccount` and other pages
 * are routed.
 *
 * If you're looking for the links rendered in the SidebarContent, go to
 * `routes/sidebar.js`
 */
const routes = [
  {
    path: '/', // the url
    component:WorkflowPage, // view rendered
  },
	{
		path:'/entities/new',
		component:EntityEditorPage
	},
	{
		path:'/elements/new',
		component:FormEditorPage
	},
  {
    path: '/:namespace/view/',
    component:WorkflowPage
  },
  {
    path: '/:namespace/edit/',
    component:WorkflowPage
  },
  {
    path: '/:namespace/delete/',
    component:WorkflowPage
  },
  {
    path: '/:namespace/:action/:id',
    component:EndpointPage
  },
  {
    path: '/:namespace/:action',
    component:EndpointPage
  },
  {
    path: '/:namespace',
    component:EndpointPage
  }
];

export default routes;
